module.exports = __webpack_public_path__ + "static/download/BaeminStory2023.pdf";